module.exports = __webpack_public_path__ + "static/media/sf-test-15.0796ed8d.mp3";